import { createLightTheme, type BrandVariants } from '@fluentui/react-components';

const undpBrand: BrandVariants = {
  10: '#021824',
  20: '#042E48',
  30: '#03456E',
  40: '#035B96',
  50: '#0468B1',
  60: '#0576C8',
  70: '#1A85CE',
  80: '#3494D4',
  90: '#4FA3DA',
  100: '#6BB2E0',
  110: '#87C1E6',
  120: '#A3D0EC',
  130: '#BFDFF2',
  140: '#D9EEF8',
  150: '#E8F4FD',
  160: '#F4FAFF',
};

export const undpTheme = createLightTheme(undpBrand);

undpTheme.fontFamilyBase = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
undpTheme.fontFamilyMonospace = "'JetBrains Mono', 'Fira Code', 'Cascadia Code', Consolas, monospace";
undpTheme.fontFamilyNumeric = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

undpTheme.colorNeutralBackground1 = '#FFFFFF';
undpTheme.colorNeutralBackground2 = '#F7F7F8';
undpTheme.colorNeutralBackground3 = '#F0F0F1';
undpTheme.colorNeutralForeground1 = '#1A1A1A';
undpTheme.colorNeutralForeground2 = '#5A5A5A';
undpTheme.colorNeutralForeground3 = '#8A8A8A';
undpTheme.colorNeutralStroke1 = '#D4D6D8';
undpTheme.colorNeutralStroke2 = '#E8E8E8';

undpTheme.colorPaletteGreenForeground1 = '#25903F';
undpTheme.colorPaletteGreenBackground1 = '#E6F4EA';
undpTheme.colorPaletteYellowForeground1 = '#B07A00';
undpTheme.colorPaletteYellowBackground1 = '#FFF8E1';
undpTheme.colorPaletteRedForeground1 = '#D12800';
undpTheme.colorPaletteRedBackground1 = '#FDECEC';

export const undpColors = {
  primary: '#0468B1',
  primaryHover: '#035B96',
  primaryLight: '#E8F4FD',
  accent: '#00A4D4',
  success: '#25903F',
  successLight: '#E6F4EA',
  warning: '#FDAD15',
  warningLight: '#FFF8E1',
  error: '#D12800',
  errorLight: '#FDECEC',
  text: '#1A1A1A',
  textSecondary: '#5A5A5A',
  textTertiary: '#8A8A8A',
  border: '#D4D6D8',
  borderLight: '#E8E8E8',
  surface: '#FFFFFF',
  background: '#F7F7F8',
} as const;
